import { render, staticRenderFns } from "./boxOne.vue?vue&type=template&id=6000298c&scoped=true&"
import script from "./boxOne.vue?vue&type=script&lang=js&"
export * from "./boxOne.vue?vue&type=script&lang=js&"
import style0 from "./boxOne.vue?vue&type=style&index=0&id=6000298c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000298c",
  null
  
)

export default component.exports